import { ModalUI, createModalUIinstances } from "./modalUI";

export class Modal {
  public constructor(private ui: ModalUI) {
    // render the wrapper into the DOM
    if (!this.isInit() ) {
      this.ui.init();
    }
    this.ui.onOpen(this.showModal.bind(this));
  }

  /**
   * Show modal
   */
  private showModal(): void {
    const data = this.ui.readData();
    window.dispatchEvent(new CustomEvent(data.openEventName, {
      detail: {
        data: data
      }
    }));
    
    // --- if disabled is not set or set to false shows (legacy js) ui, if not then just dispatch the event (top)
    if(!data.disabled) {
      this.ui.show();
      this.ui.onClose(this.hideModal.bind(this));
    }
  }

  /**
   * Hide modal
   */
  private hideModal(): void {
    const data = this.ui.readData();
    window.dispatchEvent(new CustomEvent(data.closeEventName, {
      detail: {
        data: data
      }
    }));
    this.ui.hide();
  }

  /**
   * Check if the modal already added into the DOM
   */
  private isInit(): boolean {
    const lengthOfInit: number = this.ui.countInit();
    return lengthOfInit > 0;
  }
}

export function initModal() {
  return createModalUIinstances().map((instance: ModalUI) => {
    return new Modal(instance);
  });
}
